import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Button, Input, Switchi, Textarea } from "../Form";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { toast } from "react-hot-toast";
import servicesService from "../../api/servicesService";

function AddEditServiceModal({ closeModal, isOpen, datas, onRefresh }) {
  const [check, setCheck] = useState(true); // Default Enabled
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (datas?.name) {
      setName(datas.name);
      setPrice(datas.price);
      setDescription(datas.description);
      // Backend: isDisabled. Frontend check: True = Enabled.
      // If isDisabled is true, check is false.
      // If datas.status exists (mapped from parent), use it.
      // If datas.isDisabled exists, use !isDisabled.
      if (datas.status !== undefined) {
        setCheck(datas.status);
      } else if (datas.isDisabled !== undefined) {
        setCheck(!datas.isDisabled);
      } else {
        setCheck(true);
      }
    } else {
      setName("");
      setPrice("");
      setDescription("");
      setCheck(true);
    }
  }, [datas, isOpen]);

  const submitHandler = async () => {
    try {
      if (!name || !price) {
        return toast.error("Please fill all required fields");
      }
      setLoading(true);
      const payload = {
        serviceName: name, // Backend expects serviceName
        price: Number(price),
        description,
        isDisabled: !check, // Map check(Enabled) to isDisabled
      };

      if (datas?._id || datas?.id) {
        const id = datas._id || datas.id;
        await servicesService.updateService(id, payload);
        toast.success("Service updated successfully");
      } else {
        await servicesService.createService(payload);
        toast.success("Service created successfully");
      }
      onRefresh();
      closeModal();
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      closeModal={closeModal}
      isOpen={isOpen}
      title={datas?.name ? "Edit Service" : "New Service"}
      width={"max-w-3xl"}
    >
      <div className='flex-colo gap-6'>
        <Input
          label='Service Name'
          color={true}
          placeholder='Ex: Teeth Whitening'
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <Input
          label='Price (Tsh)'
          type='number'
          color={true}
          placeholder='Ex: 20000'
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />

        {/* des */}
        <Textarea
          label='Description'
          placeholder='Write description here...'
          color={true}
          rows={5}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        {/* switch */}
        <div className='flex w-full items-center gap-2'>
          <Switchi
            label='Status'
            checked={check}
            onChange={() => setCheck(!check)}
          />
          <p className={`text-sm ${check ? "text-subMain" : "text-textGray"}`}>
            {check ? "Enabled" : "Disabled"}
          </p>
        </div>
        {/* buttones */}
        <div className='grid w-full gap-4 sm:grid-cols-2'>
          <button
            onClick={closeModal}
            className='rounded-lg bg-red-600 bg-opacity-5 p-4 text-sm font-light text-red-600'
          >
            {datas?.name ? "Discard" : "Cancel"}
          </button>
          <Button
            label={loading ? "Saving..." : "Save"}
            Icon={HiOutlineCheckCircle}
            onClick={submitHandler}
            disabled={loading}
          />
        </div>
      </div>
    </Modal>
  );
}

export default AddEditServiceModal;
